// extracted by mini-css-extract-plugin
module.exports = {"buttonStyle":"DangerZone_buttonStyle__2zF5E","deleteButton":"DangerZone_deleteButton__lvRZu","deleteColor":"DangerZone_deleteColor__3CM9T"};